class ModuleDatePicker{
    constructor(){
        $.datepicker.regional['vi'] = {
            closeText: 'Đóng',
            prevText: 'Trước',
            nextText: 'Sau',
            currentText: 'Hôm nay',
            monthNames: ['Tháng 1','Tháng 2','Tháng 3','Tháng 4','Tháng 5','Tháng 6',
                'Tháng 7','Tháng 8','Tháng 9','Tháng 10','Tháng 11','Tháng 12'],
            monthNamesShort: ['T1','T2','T3','T4','T5','T6','T7','T8','T9','T10','T11','T12'],
            dayNames: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'],
            dayNamesShort: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            dayNamesMin: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            weekHeader: 'Tu',
            dateFormat: 'dd/mm/yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ''
        };

        $.datepicker.setDefaults($.datepicker.regional['vi']);

        
        $(".input-date").datepicker({
            dateFormat: 'dd/mm/yy',
        });

        $(".input-current-date").datepicker({
            minDate: new Date(),
            dateFormat: 'dd/mm/yy',
        });

        $(".input-pass-date").datepicker({
            maxDate: new Date(),
            dateFormat: 'dd/mm/yy',
            // changeMonth: true,
            // changeYear: true,
            // yearRange: "1930:2500"

            // onSelect: function(dateText) {
            //     console.log(validateBirthday(dateText))
            // }
        });


        // let form = document.getElementById('FormInformation');
        // if(form){
        //     form.onsubmit = function(e){
        //         e.preventDefault();
        //         let dateE = document.querySelector('.input-pass-date');
        //         console.log(validateBirthday(dateE.value));
        //     }
        // }


        // GỌI VALIDATE CHO TẤT CẢ INPUT DATE
        // this.bindManualInputCheck(".input-date");
        // this.bindManualInputCheck(".input-current-date");
        // this.bindManualInputCheck(".input-pass-date");

        
        // dateE.addEventListener('input', function(){
        //     console.log(dateE.value);
        // })
    }

    bindManualInputCheck(selector){
        $(document).on("blur", selector, function () {
            let val = $(this).val().trim();

            if (!val) return;

            // Kiểm tra format dd / mm / yyyy
            let regex = /^[0-3]\d \/ [0-1]\d \/ \d{4}$/;
            if (!regex.test(val)) {
                alert("Ngày không đúng định dạng DD/MM/YYYY");
                $(this).val("");
                return;
            }

            // Split ngày tháng năm
            let [day, month, year] = val.split(" / ").map(Number);

            // Validate ngày tháng năm thật sự tồn tại
            let date = new Date(year, month - 1, day);

            if (date.getDate() !== day || date.getMonth() + 1 !== month || date.getFullYear() !== year) {
                $(this).val("");
                return;
            }

            // Check theo loại input
            if ($(this).hasClass('input-current-date')) {
                if (date < new Date().setHours(0,0,0,0)) {
                    $(this).val("");
                }
            }

            if ($(this).hasClass('input-pass-date')) {
                if (date > new Date().setHours(0,0,0,0)) {
                    $(this).val("");
                }
            }
        });
    }
}

export default ModuleDatePicker;
